<template>
  <div class="footer_box" v-if="!isAlibabaSite && footerInfo">
    <span style="margin-right: 12px;">{{ footerInfo.systemBottomFiling }}</span>
    <a href="https://beian.miit.gov.cn" target="_blank">{{ $t('key1000052') + footerInfo.domainFilingCode }}</a>
  </div>
</template>

<script>
import {commonLocalStorage} from "@/utils/common";

export default {
  name: "login-footer",
  props: {
    isAlibabaSite: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 底部的信息
    footerInfo() {
      return commonLocalStorage.getItem('pageConfig') || this.$store.state.pageConfig;
    }
  }
};
</script>

<style lang="less" scoped>
.footer_box {
  width: 100%;
  height: 50px;
  text-align: center;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333;

  a {
    color: #333;

    &:hover {
      color: #FD5425;
    }
  }
}
</style>
